export function Grain() {
  return <div aria-hidden className="grain pointer-events-none" />;
}
